import React from 'react';
import { translate } from 'react-polyglot';

import Modal from '../Modal';
import OfflineTranslate from '../OfflineTranslate'

const OfflineTranslateModal = ({ 
  assets, 
  t, 
  viewport, 
  offline, 
  userId, 
  userEmail,
  book, 
  windowDimensions, 
  startPage, 
  slug, 
  addSlimNotification, 
  isLoggedIn, 
  closeOfflineTranslator,
  saveOfflineTranslationsWorkflow, 
  postOfflineTranslateDataWorkflow, 
  unsaveOfflineTranslationsWorkflow, 
  fetchOfflineTranslationsWorkflow,
  isSubmittingOfflineTranslateData,
  offlineBooks,
  isRtl,
  updateOfflineTranslationsWorkflow,
}) => {

  if(!(assets && assets.pages)) return null;

  return (
    <Modal
      noContentPadding
      noDimensionRestrictions
      overflowVisible>
        <OfflineTranslate
          pages={assets.pages}
          cssHref={assets.css}
          viewport={viewport}
          orientation={assets.orientation}
          closeOfflineTranslator={closeOfflineTranslator}
          isLoggedIn={isLoggedIn}
          language={assets.language}
          offline={offline}
          userId={userId}
          book={book}
          t={t}
          startPage={startPage}
          windowDimensions={windowDimensions}
          slug={slug}
          addSlimNotification={addSlimNotification}
          saveOfflineTranslationsWorkflow={saveOfflineTranslationsWorkflow}
          postOfflineTranslateDataWorkflow={postOfflineTranslateDataWorkflow}
          unsaveOfflineTranslationsWorkflow={unsaveOfflineTranslationsWorkflow}
          fetchOfflineTranslationsWorkflow={fetchOfflineTranslationsWorkflow}
          assets={assets}
          isSubmittingOfflineTranslateData={isSubmittingOfflineTranslateData}
          offlineBooks={offlineBooks}
          updateOfflineTranslationsWorkflow={updateOfflineTranslationsWorkflow}
          userEmail={userEmail}
          isRtl={isRtl}
        />
    </Modal>
  );
};

export default translate()(OfflineTranslateModal);



// WEBPACK FOOTER //
// ./src/components/OfflineTranslateModal/OfflineTranslateModal.jsx